/**
 * Specifies the format of the delivery start and end time values.
 * tag: 41057
 * @readonly
 * @enum {number} (int)
 */
export enum DeliveryScheduleSettlTimeType {
  Hour = 0,
  Timestamp = 1,
}
